export default __webpack_public_path__ + "static/abstract-3096252c41c363662d23ac98ca9dab1e.png";